import { SCRIPTING_FLAGS } from 'constants/user';
import { isEmpty } from 'lodash';

export const parseUserConfigFlags = ( rawFlagInfo ) => {
  if( !rawFlagInfo || isEmpty(rawFlagInfo) || !rawFlagInfo['config-values-with-reason'] ) {
    return {};
  }
  const hasFlags = rawFlagInfo['config-values-with-reason'].reduce( (flags, flagInfo) => {
    const name = flagInfo['config-key'].replace('feature-flag.cfvweb.', '');
    if( SCRIPTING_FLAGS[name] && flagInfo['value-with-reason'].value) {
      flags[SCRIPTING_FLAGS[name]] = flagInfo['value-with-reason'].value;
    }
    return flags;
  }, {});
  return hasFlags;
};
